import React, { ComponentProps } from 'react';
import { Typography } from '../../../typography/typography';
import { DefinitionWrapper } from '../../definition-wrapper/definition-wrapper';
import isNil, { notNil } from '../../../../core/helpers/is-nil';
import styles from './definition-basic.module.scss';

type Props = {
  children: React.ReactNode;
  label?: string;
  action?: React.ReactNode;
} & Omit<ComponentProps<typeof DefinitionWrapper>, 'children'>;

export const DefinitionBasic: React.FC<Props> = ({ children, label, action, ...rest }) => {
  const hasAction = notNil(action);

  return (
    <DefinitionWrapper {...rest}>
      <span>
        {hasAction ? (
          <div className={styles.actionAlignWrap}>
            <Typography variant="smalltext">{children}</Typography>
            <span>{action}</span>
          </div>
        ) : (
          <Typography variant="smalltext">{children}</Typography>
        )}

        {label && !isNil(children) ? (
          <Typography color="anthrazit-75" fontStyle="bold" variant="smalltext">
            {label}
          </Typography>
        ) : null}
      </span>
    </DefinitionWrapper>
  );
};
